<div class="d-flex-row gap-2">
  <select class="form-control fs-4" name="game" [(ngModel)]="game">
    <option [ngValue]="undefined">Select a game...</option>
    @for ($game of games; track $game) {
      <option
        [ngValue]="$game">
        {{$game.listName}}
      </option>
    }
  </select>

  @if (this.game) {
    <button class="btn text-danger fs-4" title="Reset" (click)="reset()">
      <i class="bi-trash3-fill"></i>
    </button>
  }
</div>

@if (this.game; as $game) {
  @if ($game.vs === 'vs') {
    <div>
      <div class="bg-left-team text-white p-2 rounded-2 fs-4 text-center">Left Team</div>
      <app-guess-answers-form #blue [guesses]="$game.guesses" [answers]="match.guesses.blue!" />
    </div>
    <div>
      <div class="bg-right-team text-white p-2 rounded-2 fs-4 text-center">Right Team</div>
      <app-guess-answers-form #red [guesses]="$game.guesses" [answers]="match.guesses.red!" />
    </div>
  } @else {
    <app-guess-answers-form #answers [guesses]="$game.guesses"
    [answers]="match.guesses.answers!" />
  }
}

